module.exports = __webpack_public_path__ + "static/media/20200907_H_Solution 4.c3adff07.svg";